import { Component, OnInit } from '@angular/core';
import { AuthserviceService } from './core/services/authservice.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'web-app';
  readonly spinnerName = 'appComponentSpinner';

  ngOnInit(): void {
    this.spinner.show(this.spinnerName);
    setTimeout(() => this.spinner.hide(this.spinnerName), 0);
  }

  constructor(
    AuthService: AuthserviceService,
    private spinner: NgxSpinnerService
  ) {
   
  }
}
